export default "__VITE_ASSET__DW14AZWm__"